export default "/list/static/images/Ebookers.svg";